import React from "react";
import { BreadcrumbItem, BillingInstanceSummary, StripeProductSlimModel, ChangePlanPostModel, UserBusinessResponseModel, EmailType, BillingInstanceUsageType, SubscriptionResponseModel, ProductType } from "../../swagger-clients/s365-dashboard-v2-api-clients.service";
import { Breadcrumbs } from "s365-dashboard-v2-file-picker";
import { Avatar, Breadcrumb, Card, CardFooter, CardHeader, Text, Table, TableBody, TableCell, TableCellLayout, TableColumnSizingOptions, TableHeader, TableHeaderCell, TableRow, useTableFeatures, Button, dividerClassNames, Select, Label } from "@fluentui/react-components";
import { processServerError } from "../../utils/helpers/error.helper";
import { getSessionsClient, getStripeProductsClient, getSubscriptionsClient, getUsersClient } from "../../services/dashboard.service";
import { DateTimeDisplayUTC } from "../../components/date-time-display-utc/date-time-display-utc.component";
import { TableBodyWithLoading } from "../../components/table-body-with-loading/table-body-with-loading.component";
import TimeSpanDisplay from "../../components/timespan-display/timespan-display.component";
import { useDwsimProLicense } from "../../contexts/DwsimProLicenseContext";
import styles from "../../components/paramater-picker-next/parameter-picker-next.style.scss";
import { S365Button } from "../../components/s365-button/s365-button.component";
import DwsimProIcon from "../../assets/dwsim-pro-icon.png";
import { PeopleAddRegular } from "@fluentui/react-icons";
import { ShareSubscriptionModal } from "./share-subscription-modal";
import { ProductTypeDisplay } from "../../components/product-type/product-type.component";
type VMUsagePageProps = {

}

const emptyBreadcrumbs = [{ name: "VM usage" } as BreadcrumbItem];

export const VMUsagePage: React.FC<VMUsagePageProps> = (props) => {

    const [breadcrumbs, setBreadcrumbs] = React.useState<BreadcrumbItem[]>(emptyBreadcrumbs);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [loadingChangeUrlPriceIndex, setLoadingChangeUrlPriceIndex] = React.useState<number>();
    const [isLoadingUserDetails, setIsLoadingUserDetails] = React.useState<boolean>(true);
    const [userBusinessDetails, setUserBusinessDetails] = React.useState<UserBusinessResponseModel>();
    const [hourlyProducts, setHourlyProducts] = React.useState<StripeProductSlimModel[]>([]);
    const [monthlySummaries, setMonthlySummaries] = React.useState<BillingInstanceSummary[]>([]);
    const [showShareModal, setShowShareModal] = React.useState<boolean>(false);
    const [activeSubscriptions, setActiveSubscriptions] = React.useState<SubscriptionResponseModel[]>([]);
    const [selectedSubscription, setSelectedSubscription] = React.useState<SubscriptionResponseModel>();
    const [selectedProduct, setSelectedProduct] = React.useState<ProductType>(null);
    const [isLoadingActiveSubscriptions, setIsLoadingActiveSubscriptions] = React.useState<boolean>(false);

    React.useEffect(() => {
        getActiveSubscriptions();
        getUsageData();
        // getHourlyProducts();
        getUserDetails();
    }, []);

    React.useEffect(() => {
        getUsageData();
    }, [selectedProduct]);

    const getActiveSubscriptions = async () => {
        try {
            setIsLoadingActiveSubscriptions(true);
            const client = getSubscriptionsClient();
            const activeSubscriptionResp = await client.getAllActiveSubscriptions();
            setActiveSubscriptions(activeSubscriptionResp ?? []);

        } catch (error) {
            processServerError(error, undefined, "An error occurred while getting active subscriptions.");
        } finally {
            setIsLoadingActiveSubscriptions(false);
        }
    }

    const getUsageData = async () => {
        try {
            const client = getSessionsClient();
            const usageDataResp = await client.getUsageData(selectedProduct);
            setMonthlySummaries(usageDataResp ?? []);
        } catch (error) {
            processServerError(error, undefined, "An error occurred while getting usage data.");
        }
    }

    const getHourlyProducts = async () => {
        try {
            const client = getStripeProductsClient();
            const productsResp = await client.getHourlyProducts();
            setHourlyProducts(productsResp);
        } catch (error) {
            processServerError(error, undefined, "An error occurred while getting hourly product list.");
        }
    }

    const getUserDetails = async () => {
        try {
            setIsLoadingUserDetails(true);
            const client = getUsersClient();
            const userResp = await client.getUserBusinessDetails();
            setUserBusinessDetails(userResp);
        }
        catch (error) {
            processServerError(error, undefined, "An error occurred while getting user details.");
        } finally {
            setIsLoadingUserDetails(false);
        }
    }
    const onChangePlanClick = async (priceId: string, index: number) => {
        try {
            setLoadingChangeUrlPriceIndex(index);
            const client = getStripeProductsClient();
            const model = new ChangePlanPostModel({
                priceId: priceId
            });
            const changePlanResponse = await client.getChangePlanUrl(model);
            if (!!changePlanResponse?.url) {
                window.open(changePlanResponse.url, "_blank")
            }
        } catch (error) {
            processServerError(error, undefined, "An error occurred while getting change plan redirect URL.");
        } finally {
            setLoadingChangeUrlPriceIndex(undefined);
        }
    }

    // const showHourlyProducts = React.useMemo(() => {
    //     return (!!userBusinessDetails?.readyToOrder) || !!activeSubscription;
    // }, [userBusinessDetails, activeSubscription]);



    return <div className='page-wrapper'>
        <div className='files-wrapper' style={{ width: "100%" }}>

            <div className='files-wrapper__breadcrumbs-wrapper'>
                <Breadcrumbs>
                    {breadcrumbs.map((item: BreadcrumbItem) => {
                        return <Breadcrumb
                            key={`breadcrumb-${item.uniqueIdentifier ?? "dashboard"}`}
                        >{item.name}</Breadcrumb>
                    })}
                </Breadcrumbs>
            </div>
            <div>

                <p><u>Active subscriptions</u></p>
                <Table style={{ marginBottom: "20px" }}>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell key="product" className="files-table__cell--center files-table__cell--bold">Product</TableHeaderCell>
                            <TableHeaderCell key="product-description" className="files-table__cell--center files-table__cell--bold">Description</TableHeaderCell>
                            <TableHeaderCell key="valid-from" className="files-table__cell--center files-table__cell--bold">Started At</TableHeaderCell>
                            <TableHeaderCell key="valid-to" className="files-table__cell--center files-table__cell--bold">Ended At</TableHeaderCell>
                            <TableHeaderCell key="duration" className="files-table__cell--center files-table__cell--bold">Duration</TableHeaderCell>
                            <TableHeaderCell key="maxUsers" className="files-table__cell--center files-table__cell--bold">Max Users</TableHeaderCell>
                            <TableHeaderCell key="owner" className="files-table__cell--center files-table__cell--bold">Owner</TableHeaderCell>
                            <TableHeaderCell key="actions" className="files-table__cell--center files-table__cell--bold"></TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBodyWithLoading isLoading={isLoadingActiveSubscriptions}
                        columnCount={8} loadingMessage="Loading..."
                        itemCount={activeSubscriptions ? activeSubscriptions.length : 0}
                        noItemsMessage="No active subscriptions found.">
                        {activeSubscriptions.map((subscription) => (<>
                            <TableRow key={`subscription-${subscription.id}`} >
                                <TableCell className="column--center" ><ProductTypeDisplay productType={subscription.productType} /></TableCell>
                                <TableCell className="column--center" >
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        {!!subscription.stripeProduct?.name && <span>{subscription.stripeProduct.name}</span>}
                                        {!!subscription.stripeProduct?.description && <span>{subscription.stripeProduct.description}</span>}
                                    </div>
                                </TableCell>
                                <TableCell className="column--center" > <DateTimeDisplayUTC date={subscription.validFromUtc} hideTime /></TableCell>
                                <TableCell className="column--center" ><DateTimeDisplayUTC date={subscription.validToUtc} hideTime /></TableCell>
                                <TableCell className="column--center" >
                                    <div style={{ display: "grid", gridTemplateColumns: "auto auto", columnGap: "5px" }}>
                                        <span style={{ textAlign: "end" }}> Available:</span> <TimeSpanDisplay value={subscription.allowedDuration} hideSeconds={true} /> 
                                        <span style={{ textAlign: "end" }}> Used:</span> <TimeSpanDisplay value={subscription.usedDuration} hideSeconds={true} /> 
                                    </div>
                                </TableCell>
                                <TableCell className="column--center" >{subscription.maxUsers}</TableCell>
                                <TableCell className="column--center" >{subscription.owner}</TableCell>
                                <TableCell className="column--center" >
                                    {subscription.isSubscriptionOwner &&
                                        <Button
                                            style={{ marginLeft: "var(--spacingHorizontalSNudge)" }}
                                            appearance="primary"
                                            size="small"
                                            icon={<PeopleAddRegular />}
                                            onClick={() => { setSelectedSubscription(subscription); setShowShareModal(true) }}
                                        >Share</Button>}
                                </TableCell>
                            </TableRow>
                        </>))
                        }
                    </TableBodyWithLoading>
                </Table>

                <p><u>Product usage</u></p>
                <div style={{ display: "flex", alignItems: "center", gap: "var(--spacingHorizontalS)", marginBottom: "var(--spacingVerticalS)" }}>
                    <Label htmlFor="product-filter">Product</Label>
                    <Select
                        id="product-filter"
                        style={{ width: "200px" }}
                        value={selectedProduct ?? ""}
                        onChange={(_, data) => setSelectedProduct(data.value === "" ? null : Number(data.value) as ProductType)}
                    >
                        <option value="">All products</option>
                        <option value={ProductType.DwsimPro}>DWSIM Pro</option>
                        <option value={ProductType.DwsimSecure}>DWSIM Secure</option>
                    </Select>
                </div>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell key="product-type" className="files-table__cell--center files-table__cell--bold">Product</TableHeaderCell>
                            <TableHeaderCell key="month-first-session" className="files-table__cell--center files-table__cell--bold">Started At</TableHeaderCell>
                            <TableHeaderCell key="month-last-session" className="files-table__cell--center files-table__cell--bold">Ended At</TableHeaderCell>
                            <TableHeaderCell key="month-usage" className="files-table__cell--center files-table__cell--bold">Duration</TableHeaderCell>
                            <TableHeaderCell key="month-usage" className="files-table__cell--center files-table__cell--bold">User</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBodyWithLoading isLoading={isLoading}
                        columnCount={5} loadingMessage="Loading..."
                        itemCount={monthlySummaries ? monthlySummaries.length : 0}
                        noItemsMessage="No usage data found.">
                        {monthlySummaries.map((monthlySummary) => (<>
                            <TableRow key={`usage-${monthlySummary.validFromUtc}-${monthlySummary.validToUtc}`} style={{ backgroundColor: "var(--colorNeutralBackground5)" }}>
                                <TableCell className="column--center"><b><ProductTypeDisplay productType={monthlySummary.productType} /></b></TableCell>

                                <TableCell className="column--center" >
                                    <b><i> <DateTimeDisplayUTC date={monthlySummary.validFromUtc} hideTime /></i></b>
                                </TableCell>
                                <TableCell className="column--center"> <b><i> <DateTimeDisplayUTC date={monthlySummary.validToUtc} hideTime /></i></b></TableCell>
                                <TableCell className="column--center">
                                    <div style={{ display: "grid", gridTemplateColumns: "auto auto", columnGap: "5px" }}>
                                        <span style={{ textAlign: "end" }}> Available:</span> <b><TimeSpanDisplay value={monthlySummary.allowedDuration} hideSeconds={true} /> </b>
                                        <span style={{ textAlign: "end" }}> Used:</span> <b><TimeSpanDisplay value={monthlySummary.usedDuration} hideSeconds={true} /> </b>
                                    </div>
                                </TableCell>
                                <TableCell className="column--center"></TableCell>
                            </TableRow>

                            {!!monthlySummary.sessions && monthlySummary.sessions.length > 0 && monthlySummary.sessions.map((session, index) => {
                                return <TableRow key={`session-${index}`}>
                                    <TableCell></TableCell>
                                    <TableCell className="column--center">
                                        <DateTimeDisplayUTC date={session.startedAtUtc} />
                                    </TableCell>
                                    <TableCell className="column--center">
                                        {!!session.endedAtUtc ? <DateTimeDisplayUTC date={session.endedAtUtc} /> : "Currently active"}
                                    </TableCell>
                                    <TableCell className="column--center">
                                        <TimeSpanDisplay value={session.duration} hideSeconds={true} />
                                    </TableCell>
                                    <TableCell className="column--center">{session.userDisplayName}</TableCell>
                                </TableRow>
                            })}


                        </>

                        ))}
                    </TableBodyWithLoading>
                </Table>

            </div>
        </div>
        {showShareModal && !!selectedSubscription && <ShareSubscriptionModal
            isOpened
            maxUsers={selectedSubscription.maxUsers}
            ownerCantUseLicense={!!selectedSubscription.ownerCantUse}
            isOrganizationLicense={selectedSubscription.usageType == BillingInstanceUsageType.Unlimited}
            subscriptionId={selectedSubscription.id}
            billingInstanceId={selectedSubscription.billingInstanceId}
            onClose={() => { setShowShareModal(false); setSelectedSubscription(undefined); }}
        />}
    </div>
}